var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 5.55591H4.81532H16.666",
    stroke: "#E11D34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03646 5.55594V4.0746C7.03646 3.68172 7.19253 3.30494 7.47033 3.02714C7.74814 2.74933 8.12492 2.59326 8.51779 2.59326H11.4805C11.8733 2.59326 12.2501 2.74933 12.5279 3.02714C12.8057 3.30494 12.9618 3.68172 12.9618 4.0746V5.55594M15.1838 5.55594V15.9253C15.1838 16.3182 15.0277 16.695 14.7499 16.9728C14.4721 17.2506 14.0953 17.4066 13.7025 17.4066H6.29579C5.90291 17.4066 5.52613 17.2506 5.24833 16.9728C4.97052 16.695 4.81445 16.3182 4.81445 15.9253V5.55594H15.1838Z",
    stroke: "#E11D34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51758 9.25928V13.7033",
    stroke: "#E11D34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4824 9.25928V13.7033",
    stroke: "#E11D34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDelete);
export default __webpack_public_path__ + "static/media/ic_delete.f3ee8600d76a6e389fdad6bd38f580f9.svg";
export { ForwardRef as ReactComponent };